export default __webpack_public_path__ + "static/media/emptycart.11ff25c6.svg";